import * as React from 'react'

function IconCloverBlocked({
  isFill,
  props,
}: {
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={104}
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g filter="url(#prefix__filter0_clover)">
            <path
              d="M98.978 43.072a22.383 22.383 0 000 17.85c6.706 15.438 6.951 29.48-.812 37.244-7.76 7.763-21.801 7.514-37.239.812a22.38 22.38 0 00-17.849 0c-15.437 6.706-29.483 6.951-37.246-.812-7.76-7.764-7.51-21.806-.809-37.244a22.382 22.382 0 000-17.85c-6.705-15.437-6.954-29.48.81-37.243 7.766-7.76 21.808-7.51 37.245-.805a22.38 22.38 0 0017.85 0c15.437-6.706 29.478-6.954 37.238.809 7.763 7.763 7.518 21.806.813 37.24z"
              fill="#A2A2A2"
            />
            <path
              d="M82.446 96.973c-5.251 0-11.543-1.539-18.192-4.447a29.493 29.493 0 00-11.9-2.493c-4.118 0-8.12.838-11.9 2.489-6.649 2.909-12.94 4.447-18.195 4.447-4.795 0-8.46-1.243-10.89-3.69-5.106-5.148-4.82-16.371.751-29.294a30.389 30.389 0 000-23.974c-5.57-12.922-5.86-24.146-.75-29.293 2.43-2.444 6.09-3.687 10.885-3.687 5.255 0 11.547 1.538 18.2 4.447a29.49 29.49 0 0011.9 2.49c4.117 0 8.12-.839 11.9-2.494 6.648-2.908 12.94-4.447 18.195-4.447 4.79 0 8.451 1.24 10.882 3.687 5.11 5.148 4.824 16.37-.747 29.294a30.389 30.389 0 000 23.973c5.57 12.923 5.857 24.146.747 29.293-2.43 2.456-6.095 3.699-10.886 3.699z"
              fill="#A2A2A2"
              stroke="#fff"
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
            <path
              d="M38.649 37.946L65.35 65.51M65.351 37.946L38.65 65.51"
              stroke="#fff"
              strokeWidth={6}
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
          </g>
          <defs>
            <filter
              id="prefix__filter0_clover"
              x={0}
              y={0}
              width={104}
              height={104}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M98.075 43.244a21.952 21.952 0 000 17.507c6.577 15.14 6.817 28.913-.797 36.527-7.61 7.614-21.382 7.37-36.522.797a21.95 21.95 0 00-17.506 0c-15.14 6.577-28.916 6.817-36.53-.797C-.89 89.664-.646 75.89 5.927 60.75a21.952 21.952 0 000-17.507C-.65 28.104-.893 14.331 6.72 6.717c7.618-7.61 21.39-7.367 36.53-.79a21.95 21.95 0 0017.506 0c15.14-6.577 28.912-6.82 36.522.794 7.614 7.614 7.374 21.386.797 36.523z"
            fill="#fff"
            stroke="#A2A2A2"
            strokeWidth={2}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M81.86 96.108c-5.15 0-11.32-1.509-17.841-4.362a28.928 28.928 0 00-11.672-2.445c-4.038 0-7.964.823-11.67 2.442-6.522 2.853-12.692 4.361-17.846 4.361-4.703 0-8.296-1.219-10.68-3.62-5.008-5.048-4.728-16.055.736-28.73a29.804 29.804 0 000-23.512c-5.464-12.674-5.748-23.682-.736-28.73 2.383-2.397 5.974-3.616 10.676-3.616 5.154 0 11.325 1.509 17.85 4.361a28.924 28.924 0 0011.67 2.442c4.04 0 7.965-.822 11.672-2.445C70.539 9.4 76.71 7.892 81.865 7.892c4.698 0 8.288 1.215 10.672 3.616 5.012 5.049 4.731 16.056-.733 28.73a29.805 29.805 0 000 23.513c5.464 12.674 5.745 23.681.733 28.73-2.384 2.408-5.978 3.627-10.676 3.627z"
            fill="#A2A2A2"
            stroke="#fff"
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M38.906 38.216L65.095 65.25M65.095 38.216L38.905 65.25"
            stroke="#fff"
            strokeWidth={6}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconCloverBlocked
